export enum OfferSaveStatus {
  Failed = 'FAILED',
  Started = 'STARTED',
  Success = 'SUCCESS',
}
